<template>
  <div>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>{{ this.$l('v_rating_title') || '综合考评' }}</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-rating role="button" style="color: #606266">
            <i v-if="isRating" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isRating" id="collapse-rating">
        <el-row :gutter="10">
          <el-col :span="14">
            <vxe-grid
              class="mt-3"
              ref="table"
              round
              auto-resize
              highlight-hover-row
              :height="tableHeight"
              :tree-config="treeConfig"
              :columns="tableColumn"
              :data="formData.scoreData"
              :loading="loading"
              :seq-config="{}"
              size="mini"
            >
              <template v-slot:empty="{}">
                <div style="text-align: center">
                  <img src="/image/static/img/nodata.png" />
                  <p class="no-data">
                    {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
                  </p>
                </div>
              </template>
            </vxe-grid>
          </el-col>
          <el-col :span="7" :offset="1">
            <div class="d-flex mt-2">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px">{{
                  this.$l('v_label_total') || '考评总分：'
                }}</span>
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{
                  formData.totalTopScore
                }}</span>
              </div>
            </div>
            <div class="d-flex mt-2">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px">{{
                  this.$l('v_label_score') || '综合得分：'
                }}</span>
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.scmScore }}</span>
                <el-divider direction="vertical"></el-divider>
                <span style="font-size: 14px"
                  >{{ this.$l('v_label_percentage') || '达标率：'
                  }}{{ formData.scmScoreRatio }}</span
                >
              </div>
            </div>
            <div style="width: 100%; height: 300px" class="mt-4">
              <v-echarts
                :option="optionsRating"
                auto-resize="true"
                theme="light"
                style="width: 100%; height: 100%"
                ref="echartsRating"
              ></v-echarts>
            </div>
          </el-col>
        </el-row>
      </b-collapse>
    </el-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object
    }
  },
  watch: {
    params: {
      handler() {
        if (this.params.scmCode) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isRating: true,
      formData: {
        totalTopScore: '',
        scmScore: '',
        scmScoreRatio: '',
        scoreData: []
      },
      loading: false,
      tableData: [],
      tableHeight: 400,
      treeConfig: {
        children: 'listItem',
        expandAll: false
      },
      tableColumn: [
        { type: 'seq', width: 50 },
        {
          field: 'itemName',
          title: '评价项目',
          minWidth: 280,
          treeNode: true
        },
        // { field: 'itemValue', title: '数值结果', minWidth: 250 },
        {
          field: 'topScore',
          title: '满分值',
          width: 80,
          align: 'center'
        },
        {
          field: 'scmScore',
          title: '实际得分',
          width: 80,
          align: 'center'
        }
      ],
      optionsRating: {}
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeTheChart)
  },
  activated() {
    window.addEventListener('resize', this.resizeTheChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTheChart)
  },
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      this.loading = true
      this.$api
        .scmInfoGetScoreListApi(params)
        .then((res) => {
          this.loading = false
          this.formData = res.body
          // 设置图形数据参数
          this.setChartsData()
          //设置评分指标项表格数据
          this.setScoringItem(this.formData)
        })
        .catch(() => {
          this.loading = false
        })
    },
    setChartsData() {
      this.optionsRating = {
        title: {},
        tooltip: {},
        legend: {
          data: []
        },
        radar: {
          shape: 'circle',
          name: {
            textStyle: {
              color: '#fff',
              backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: this.formData.chartsIndicator,
          center: ['50%', '50%'],
          radius: 100
        },
        series: [
          {
            type: 'radar',
            areaStyle: {},
            data: this.formData.chartsData
          }
        ]
      }
    },
    setScoringItem(data) {
      data.scoreData.map((res) =>
        res.listItem.map((data) => this.tableData.push(data))
      )
    },
    resizeTheChart() {
      if (this.$refs.echartsRating) {
        this.$refs.echartsRating.resize()
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
